export const DEFAULT_LEAD_FORM_HEADING = "We're here to help";
export const DEFAULT_LEAD_FORM_BODY = "Let us know how we can reach you and what you'd like to discuss.";
export const DEFAULT_LEAD_FORM_SUBMIT_LABEL = 'Send message';
